// Utility to compute assessment status counts
export function isAssessmentCompleted(a) {
  if (!a || !Array.isArray(a.questionnaires) || a.questionnaires.length === 0) return false;
  return a.questionnaires.every(q => (q.totalQuestion ?? 0) > 0 && (q.answered ?? 0) >= (q.totalQuestion ?? 0));
}


export function isAssessmentProcessing(a) {
  if (!a || !Array.isArray(a.questionnaires) || a.questionnaires.length === 0) return false;
  const allComplete = isAssessmentCompleted(a);
  if (allComplete) return false;
  return a.questionnaires.some(q => (q.answered ?? 0) > 0);
}

// Per-assessment label matching the dashboard card buckets
export function getAssessmentStatusLabel(a) {
  if (isAssessmentCompleted(a)) return 'Completed';
  if (isAssessmentProcessing(a)) return 'Processing';
  return 'Pending';
}

// Build an assessmentId -> status label lookup from a CountInfo response,
// whose items are keyed by `id`.
export function buildStatusMapFromCountInfo(arr = []) {
  const map = {};
  (Array.isArray(arr) ? arr : []).forEach(a => {
    if (a?.id == null) return;
    map[String(a.id)] = getAssessmentStatusLabel(a);
  });
  return map;
}

export function getCountsFromAssessments(arr = []) {
  const total = Array.isArray(arr) ? arr.length : 0;
  const completed = Array.isArray(arr)
    ? arr.filter(isAssessmentCompleted).length
    : 0;
  const processing = Array.isArray(arr)
    ? arr.filter(isAssessmentProcessing).length
    : 0;
  const pending = Math.max(0, total - completed - processing);
  return { total, completed, processing, pending };
}

export default {
  isAssessmentCompleted,
  isAssessmentProcessing,
  getAssessmentStatusLabel,
  buildStatusMapFromCountInfo,
  getCountsFromAssessments,
};
